// extracted by mini-css-extract-plugin
module.exports = {"testimonialsCards":"ArticlesSlider_testimonialsCards__2yABb","testimonialsCard":"ArticlesSlider_testimonialsCard__2EZWh","cardWrapper":"ArticlesSlider_cardWrapper__1l_j-"};